export const CodResp = [
    // PROCESO_OK
    {'codigo': 'M00', 'nombre': 'Proceso exitoso'},
	// NO_AUTORIZADO
    {'codigo': 'M01','nombre': 'Usuario no autorizado'},
    // RESP_NO_GUARDADA
    {'codigo': 'M02', 'nombre':'No ha sido registrada la respuesta'},
    //ITEMS_NO_OBTENIDOS
    {'codigo': 'M03', 'nombre':'No ha sido posible obtener el listado de ítems para el usuario'},
    // CONF_NO_OBTENIDA
    {'codigo': 'M04','nombre':'No ha sido posible obtener la aplicación de la aplicación' },
    // NO_FINALIZA_EXAMEN
    {'codigo': 'M05', 'nombre':'No fue posible finalizar el exámen' },
    // INFO_BIENV_NO_CARGA
    {'codigo': 'M06','nombre':'No ha sido posible cargar la información de bienvenida' },
    // RESPS_NO_OBTENIDAS
    {'codigo': 'M07', 'nombre':'No ha sido posible consultar las respuestas asociadas a un usuario' },
    // CAMBIO_NOMBRE_FALLO
    {'codigo': 'M08', 'nombre':'No fue posible actualizar el nombre del usuario' },
    // SINC_BD_FALLO
    {'codigo': 'M09', 'nombre':'No fue posible sincronizar las bases de datos' },
    // NUM_SESION_FALLO
    {'codigo': 'M10', 'nombre':'No fue posible obtener el número de sesiones finalizadas' },
    // INFO_SITIO_FALLO
    {'codigo': 'M11', 'nombre':'No fue posible obtener los datos del sitio de aplicación' },
    // ACT_SESION_FALLO
    {'codigo': 'M12', 'nombre':'No fue posible actualizar la infomación de la sesión' },
    // GRD_SESION_FALLO
    {'codigo': 'M13', 'nombre':'No fue posible guardar la infomación de la sesión' },
    // REC_CACHE_FALLO
    {'codigo': 'M14','nombre':'No fue posible recargar cache' },
    // INF_ITEM_FALLO
    {'codigo': 'M15','nombre':'No fue posible consultar el ítem' },
    // RESP_IDITEM_FALLO
    {'codigo': 'M16', 'nombre':'No ha sido posible consultar la información de respuestas por Id de ítem' },
    // ACT_RESP_FALLO
    {'codigo': 'M17', 'nombre':'No ha sido posible actualizar la respuesta' },
    // RESP_ARCH_FALLO
    {'codigo': 'M18', 'nombre':'No ha sido posible procesar el archivo de respuestas' },
    // RECUP_INF_FALLO
    {'codigo': 'M19', 'nombre':'No fue posible obtener la información de avance de usuario' },	
    // GRD_CRONO_FALLO
    {'codigo': 'M20', 'nombre':'No ha sido posible actualizar la información de cronómetro' },
    //INFO_CRONO_FALLO
    {'codigo': 'M21', 'nombre':'No ha sido posible obtener la información de cronómetro' },
    // FLAG_DEMO_FALLO
    {'codigo': 'M22', 'nombre':'No ha sido posible obtener información de configuración demo' },
    // INFO_CMBS_FALLO
    {'codigo': 'M23', 'nombre':'No ha sido posible cargar la información asociada a las pruebas demo' },
    // USR_DEMO_FALLO
    {'codigo': 'M24', 'nombre':'No ha sido posible acceder a la información del usuario demo' },
    //	DOC_DEMO_FALLO
    {'codigo': 'M25', 'nombre':'No ha sido posible obtener la información de los tipos de documento' },
    //  USUARIO_BLOQUEADO
    {'codigo' : 'M26','nombre':'Su usuario fue bloqueado por incurrir en una falta o conducta prohibida.'},
    // ERRORES DE TIMEOUT
    {'codigo': 'M99', 'nombre':'Error al intentar conectar con el servicio'}

];

